import React from 'react';
import { SearchPage } from '../../search/SearchPage';

export default function EnterpriseSearchPage() {
  return <SearchPage hideHeader />;
}
